import React from 'react'
import classes from './PatientTypingBubble.module.css'

/**
 * Shown to the clinician while the patient is composing, mirroring their draft
 * text live.
 *
 * Rendered outside the messages array on purpose: it is not a message, has no
 * database key, and must never be mistaken for one. Styling is muted and
 * italic to reinforce that.
 *
 * The timestamp comes from the local clock -- the indicator is ephemeral and
 * nothing is persisted for it.
 *
 * Accessibility: the draft text changes on every keystroke, so it is NOT a live
 * region (that would read the patient's half-typed text aloud). Screen readers
 * get a static, visually hidden "<name> is typing" status instead.
 */
const PatientTypingBubble = ({ name, initial, text }) => {
    const time = new Date().toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
    })

    const displayName = name || 'Patient'

    return (
        <li className={classes.row}>
            <span className={classes.srOnly} role="status">
                {`${displayName} is typing`}
            </span>
            <div className={classes.avatar}>{initial || 'P'}</div>
            <div className={classes.stack}>
                <span className={classes.author}>{displayName}</span>
                <div className={classes.bubble}>{text}</div>
                <span className={classes.time}>{time}</span>
            </div>
        </li>
    )
}

export default PatientTypingBubble
